import { useErrorNotifier } from "components/instrumentation/source";

import { BrandSegment, DescriptionType } from "./types";

interface Props {
  brandSegment?: BrandSegment;
  descriptionType?: DescriptionType;
}

export interface Config {
  title: string;
  descriptionTranslationKey: string;
  backgroundColor: string;
}

export function useBrandSegmentConfig({
  brandSegment,
  descriptionType = "singular",
}: Props): Config | null {
  const { notify } = useErrorNotifier();

  if (!brandSegment) return {} as Config;

  const configByBrandSegment: Record<BrandSegment, Config> = {
    [BrandSegment.POWERED_BY_SONDER]: {
      title: "Powered by Sonder",
      descriptionTranslationKey: `brandSegment.poweredBySonder.${descriptionType}Description`,
      backgroundColor: "cobaltBlue",
    },
    [BrandSegment.HOTEL]: {
      title: "Sonder Hotel",
      descriptionTranslationKey: `brandSegment.hotel.description`,
      backgroundColor: "cobaltBlue",
    },
  };

  const config = configByBrandSegment?.[brandSegment];

  if (!config) {
    const error = new Error(
      `[useBrandSegmentConfig]: No config available for the given brand segment: '${brandSegment}', use [${Object.values(
        BrandSegment,
      ).join(" ,")}] instead.`,
    );

    notify(error);
  }

  return config ?? ({} as Config);
}
